<template>
    <div class="card" @click="showCard(contact_v)">
        <div class="name">{{contact_v.name + " " + contact_v.surname }}</div>
        <div class="role">{{contact_v.type.name | i18n }}</div>
        <div class="tel"><v-icon size="18px">phone</v-icon>{{contact_v.phone}}</div>
        <div class="email"><v-icon size="18px">email</v-icon>{{contact_v.email}}</div>

    </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  components: { },
  props: { contact: Object },
  data () {
    return {
      contact_v: {}
    }
  },
  computed: {

  },
  methods: {
	  	showCard( contact ){
          var self = this;
          this.$store.dispatch( 'persons/load_by_id', { id: contact.id } ).then( function(){
              var oPerson = self.$store.getters[ 'persons/get_by_id' ]( contact.id );
              var currentRole = {};
              for( var i=0; i < oPerson.current_roles.length; i++ ){
                var role = oPerson.current_roles[ i ]
                if( role.contact_type_id == contact.type.id ) currentRole = role;
              }
              oPerson.role = currentRole
              self.$card.person( oPerson )
          })
      }
  },
  created() {
    this.contact_v = {...this.contact}
    this.contact_v.surname = this.contact_v.surname == null ? '' : this.contact_v.surname
  },

  filters: {
	  	
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .card {
    padding: 10px;
    padding-left: 15px;
    border-radius: 3px;
    margin-bottom: 15px;
    background-color: #fff;
    border-left: 5px solid #4a4a4a;
    background: url('/img/right-arrow.svg') no-repeat right 10px center #fff;
    background-size: 20px;
    cursor: pointer;

    .name {
      @include font-size(16px);
      font-family: $text-bold;
      color: $main-color;
    }

    .v-icon {
      margin-right: 5px;
    }
    .role {
      @include font-size(13px);
      color: #999;
      margin-bottom: 5px;
    }
    .tel {
      @include font-size(13px);
    }
    .email {
      @include font-size(13px);
    }

  }

</style>